import styled from '@emotion/styled';
import { theme, media } from '@vfit/shared/themes';
import { ICSSProps } from './textInput.models';

export const ErrorMessage = styled.p`
  position: relative;
  animation: fadein 2s;
  margin-block: 0;
  margin-inline: 0;
  margin-bottom: -2px !important;
  color: ${theme.colors.text.error};
  font-family: ${theme.typography.fontFamily.primary};
  font-size: ${theme.typography.fontSize.caption};
  line-height: ${theme.typography.lineHeight.body1};
  text-align: left;

  @keyframes fadein {
    from {
      opacity: 0;
    }

    to {
      opacity: 1;
    }
  }

  ${media.desktop`
    margin-bottom: -${theme.spacing.sm} !important;
  `}
`;

export const Fieldset = styled.div<ICSSProps>`
  position: relative;
  margin: 0;
  padding: 18px 16px 18px 20px;
  display: flex;
  transition: border 2s;
  border-radius: 5.008px;
  background: transparent;
  ${(props) => {
    if (props.error) {
      return `border: ${theme.borderWidth.thin} solid ${theme.colors.border.error}`;
    }
    return `border: ${theme.borderWidth.thin} solid ${theme.colors.bg.disabled}`;
  }};

  .wrapper {
    display: inline-flex;
    width: 100%;
    margin: 0;
    padding: 0;
    height: 22px;
  }

  .wrapper-icon {
    display: flex;
    align-self: center;
  }

  .icon {
    position: relative;
    margin: auto;
    display: flex;
    flex-direction: column;
    appearance: none;
    background: none;
    border: none;
    font-family: inherit;
    font-size: inherit;
    padding: 0;

    &:hover {
      cursor: ${(props) => (props.isDisabled ? 'not-allowed' : 'pointer')};
    }
  }

  ${(props) => (props.isDisabled ? '&:hover {cursor: not-allowed}' : '')}
`;

// div for inputs
export const Field = styled.input<ICSSProps>`
  background-color: transparent;
  margin: auto;
  padding: 0;
  width: 100%;
  height: 22px;
  outline: 0;
  border: 0;
  text-overflow: ellipsis;
  font-family: ${theme.typography.fontFamily.primary};
  font-size: ${theme.typography.fontSize.body1};
  text-align: left;

  &:disabled {
    background-color: transparent;
    cursor: not-allowed;
  }

  &:read-only {
    color: ${theme.colors.bg.disabled};
    background-color: transparent;
    cursor: not-allowed;
  }

  &:focus {
    outline: none;
  }

  &::placeholder {
    color: ${theme.colors.text.primary};
    transition: color 0.2s;
  }

  &:focus::placeholder {
    color: transparent;
  }

  &:-webkit-autofill,
  &:-webkit-autofill:hover,
  &:-webkit-autofill:focus,
  &:-webkit-autofill:active {
    box-shadow: 0 0 0 30px white inset !important;
  }

  &:not(:placeholder-shown) ~ label,
  &:focus ~ label {
    top: -10px;
    font-size: ${theme.typography.fontSize.body3};
    line-height: ${theme.typography.lineHeight.h6};
    z-index: 2;
    color: ${theme.colors.text.primary};
  }

  ${media.tablet`
    margin: auto;
  `}
`;

export const Legend = styled.label<ICSSProps>`
  color: ${theme.colors.text.tertiary};
  height: 18px;
  padding: 0 ${theme.spacing.sm};
  margin-left: -8px;
  margin-top: 1px;
  background: ${theme.colors.bg.primary};
  z-index: -2;
  font-size: ${theme.typography.fontSize.body1};
  font-family: ${theme.typography.fontFamily.primary};
  text-align: left;
  position: absolute;
  transition: 0.2s;
`;

